import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { EmployeesServiceProvider } from '../../api/employees'

const EmployeesService = EmployeesServiceProvider()
const name = 'employeeAssignTag'

export default (employeeId, tagId) => (asyncAction(
  name,
  EmployeesService.assignTag,
  { employeeId, tagId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/employee/employeeAssignTag.js